module.exports = __webpack_public_path__ + "fonts/Avenir-Roman.eced134.woff";